import { Component, OnDestroy } from '@angular/core';
import {
  NbAuthOAuth2Token,
  NbAuthResult,
  NbAuthService,
  NbAuthToken,
} from '@nebular/auth';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../../../apps/admin/src/environments/environment';

@Component({
  selector: 'nb-playground-auth',
  template: `
    <h1 id="title" class="title">Connect your Account</h1>
    <p class="sub-title">Log in using your Square Seller Account.</p>
    <small
      >All permissions must be granted for integration to function
      properly.</small
    >

    <div class="mt-3 mb-3">
      <nb-checkbox [(checked)]="requestOrganization">
        Authorize as franchise organization
      </nb-checkbox>
      <p
        *ngIf="requestOrganization"
        class="text-hint mt-1"
        style="font-size: 0.85em;"
      >
        This will authorize access to all franchise locations under your
        organization. Authorization may take up to 1 minute to complete.
      </p>
    </div>

    <button nbButton fullWidth size="giant" status="success" (click)="login()">
      Connect with Square
    </button>
  `,
})
export class OAuth2LoginComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  requestOrganization = false;

  constructor(private authService: NbAuthService) {}

  login() {
    const baseURL = `${environment.squareBaseURL}/oauth2/authorize`;
    const clientId = environment.squareClientID;
    const redirectURI = `${window.location.origin}/auth/oauth2/callback`;
    const state = this.createState();
    localStorage.setItem('state', state);
    if (this.requestOrganization) {
      localStorage.setItem('requestOrganization', 'true');
    } else {
      localStorage.removeItem('requestOrganization');
    }
    const scope: string[] = [
      'PAYMENTS_WRITE',
      'PAYMENTS_READ',
      'ORDERS_WRITE',
      'ORDERS_READ',
      'ITEMS_READ',
      'CUSTOMERS_READ',
      'CUSTOMERS_WRITE',
      'MERCHANT_PROFILE_READ',
      'EMPLOYEES_READ',
      'INVENTORY_READ',
    ];
    const session = false;
    let url = `${baseURL}?client_id=${clientId}&scope=${scope.join(
      '+'
    )}&response_type=code&redirect_uri=${redirectURI}&session=${session}&state=${state}`;
    if (this.requestOrganization) {
      url += '&request_organization=true';
    }
    window.open(url, '_self');
  }

  logout() {}

  private createState(): string {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);

    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
      ''
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
